import BaseViewController from "./base-view-controller";

class ForgotPasswordViewController extends BaseViewController {
  handleButtonClick(name, text, action) {
    switch (name) {
      case "redirectToLogin":
        window.location.href = "/signin";
        break;
      default:
        super.handleButtonClick(name, text, action);
        break;
    }
  }
}

export default ForgotPasswordViewController;
